<template>
  <div class="main">
    <my_menu active_name="0-2" :open_active="['0']"></my_menu>

    <div class="content">
      <div class="content_tabs">
        <div class="left_user_list">
          <div
            v-for="(item, i) in role_list"
            :key="i"
            :class="current_tab == i ? 'role_list' : 'role_list2'"
            @click="click_tab(item, i)"
          >
            <span>
              <Icon type="md-contacts" color="#888" size="18" />

              {{ item.name }}
            </span>

            <span class="people_count" @click.stop="get_role_user_list(item)"
              >({{ item.count }})</span
            >
          </div>

          <div class="add_role_div" @click="add_role_show = true">
            <Icon type="ios-add-circle-outline" />&nbsp;添加角色
          </div>
        </div>

        <div class="table_box">
          <div class="table_box_inner" v-if="sys_list">
            <div>
              <div
                v-for="(item, i) in sys_list"
                :key="i"
                @click="menu_select(i)"
                :class="current_menu == i ? 'role_list' : 'role_list2'"
              >
                <div class="role_txt">
                  <Icon type="ios-cog" size="16" color="#666" style="margin-right: 5px" />

                  {{ item.name }}
                </div>

                <span> ({{ item.auth_count }}) </span>
              </div>
            </div>
          </div>

          <div class="table_data1">
            <Spin fix size="large" v-if="table_loading"></Spin>

            <!-- <div>
    
        
    
                      <Tabs @on-click="click_auth_type" v-model="auth_type" size="small">
    
        
    
                        <TabPane label="应用" name="1"></TabPane>
    
        
    
                        <TabPane label="API" name="0"></TabPane>
    
        
    
                      </Tabs>
    
        
    
                    </div> -->

            <Table
              size="small"
              @on-selection-change="table_select_change"
              :height="windowHeight - 80"
              border
              :columns="columns"
              :data="authority_list"
            >
              <template #name="{ row }">
                <div>
                  <span class="name">{{ row.name }}</span
                  ><Icon type="md-create" />
                </div>
              </template>
            </Table>
            <div class="change_div">
              <div v-if="role_list" class="role_list_span">
                <span v-if="this.role_list[Number(this.current_tab)]"
                  >{{ role_list[Number(this.current_tab)]["role_id"] }}
                </span>
                <span style="margin: 0 5px">/</span>
                <span v-if="this.sys_list[Number(this.current_menu)]"
                  >{{ sys_list[Number(this.current_menu)]["auth_sys_id"] }}
                </span>
              </div>
              <Button type="primary" @click="click_update_role">确认更新权限</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Modal width="420" v-model="add_role_show" title="添加角色" :footer-hide="true">
    <div>
      <Form ref="add_role" :model="add_role_data" :rules="add_role_rules" inline>
        <FormItem prop="name">
          <div class="form_item">
            <div class="form_item_title">角色名称：</div>

            <Input
              style="width: 250px"
              type="text"
              v-model="add_role_data.name"
              placeholder="角色名称"
            >
            </Input>
          </div>
        </FormItem>

        <div class="add_sys_button">
          <Button type="primary" @click="add_role('add_role')">确认添加</Button>
        </div>
      </Form>
    </div>
  </Modal>

  <Drawer width="620px" title="角色用户列表" :closable="false" v-model="role_user_show">
    <div class="role_id_div">
      {{ current_role_item.name }}-{{ current_role_item.role_id }}
    </div>

    <Table
      :height="windowHeight - 120"
      size="small"
      :columns="role_user_columns"
      :data="role_user_table_data"
    ></Table>
  </Drawer>
</template>

<script>
import my_menu from "@/component/admin/menu/menu.vue";
import { http } from "@/utils/http.js";
import { setTimeout } from "timers";

export default {
  components: {
    my_menu,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      // 标签页
      role_list: [],
      current_tab: 0,

      auth_type: 0,
      //添加角色
      add_role_show: false,
      add_role_data: {
        name: "",
      },
      add_role_rules: {
        name: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
          { type: "string", min: 2, message: "请输入角色名称", trigger: "blur" },
        ],
      },
      //权限表格
      authority_list: [],
      columns: [],
      table_loading: false,

      //系统列表
      menu_show: false,
      sys_list: [],
      current_menu: "0",

      role_user_show: false,

      current_role_item: {},
      role_user_table_data: [],
      role_user_columns: [],

      //
      table_select_list: [],
    };
  },

  mounted() {
    this.window_change();
    this.get_role_list();
  },

  methods: {
    click_auth_type() {
      this.get_role_list();
    },
    role_tag_close(e) {
      console.log(e);
    },

    //选择某一项
    table_select_change(selection) {
      this.table_select_list = selection;
    },

    click_update_role() {
      var selection = this.table_select_list;
      var auth_id_list = [];
      for (let i = 0; i < selection.length; i++) {
        auth_id_list.push(selection[i]["auth_id"]);
      }
      var that = this;
      that.table_loading = true;
      var obj = {
        auth_sys_id: this.sys_list[Number(this.current_menu)]["auth_sys_id"],
        role_id: this.role_list[Number(this.current_tab)]["role_id"],
        auth_id_list: auth_id_list,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/authority_manage/role/update_role",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_role_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // tab拖动
    drag_drop(name, newName, a, b, names) {
      var role_id_list = [];
      for (let i = 0; i < names.length; i++) {
        var role_id = this.role_list[Number(names[i])]["role_id"];
        console.log(role_id);
        role_id_list.push(role_id);
      }
      var that = this;
      var obj = {
        role_id_list: role_id_list,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/authority_manage/role/update_role_weight",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_role_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 点击系统
    menu_select(e) {
      this.current_menu = e;
      this.get_auth_list();
    },

    //获取角色下的人员列表
    get_role_user_list(item) {
      this.current_role_item = item;
      var that = this;
      var obj = {
        role_id: item.role_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/authority_manage/role/role_user_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res.data);
            that.role_user_show = true;
            that.role_user_table_data = res.data.table_data;
            that.role_user_columns = res.data.columns;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取系统列表
    get_sys_list() {
      var that = this;
      var obj = {
        role_id: this.role_list[Number(this.current_tab)]["role_id"],
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/authority_manage/role/sys_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log("获取角色下的系统", res);
            that.sys_list = res.data.sys_list;
            setTimeout(function () {
              that.menu_show = true;
            }, 1000);
            that.get_auth_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //点击角色
    click_tab(item, index) {
      this.current_tab = index;
      this.get_sys_list();
      this.get_auth_list();
    },

    //获取角色权限列表
    get_auth_list() {
      var that = this;
      var obj = {
        role_id: this.role_list[Number(this.current_tab)]["role_id"],
        auth_sys_id: this.sys_list[Number(this.current_menu)]["auth_sys_id"],

        auth_type: this.auth_type,
      };
      that.table_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/authority_manage/role/auth_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.authority_list = res.data.authority_list;
            that.columns = res.data.columns;
            // that.get_sys_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;
          console.log(res, "请求出错");
        });
    },

    //添加新角色
    add_role(name) {
      var that = this;
      this.$refs[name].validate((valid) => {
        console.log(valid);
        if (valid) {
          var obj = {
            name: this.add_role_data.name,
          };
          http(
            "post",
            process.env.VUE_APP_HOST + "/authority_manage/role/add_role",
            obj,
            true
          )
            .then((res) => {
              if (res.code == 0) {
                that.get_role_list();
                that.add_role_show = false;
              } else {
                that.$Message.error({
                  content: res.msg,
                  duration: 3,
                });
              }
            })
            .catch((res) => {
              console.log(res, "请求出错");
            });
        }
      });
    },

    //获角色列表
    get_role_list() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/authority_manage/role/role_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.role_list = res.data.role_list;

            that.get_sys_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_role_id() {
      var role_id = this.role_list[Number(this.current_tab)]["role_id"];
      this.$Copy({
        text: role_id,
      });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.role_txt {
  display: flex;
  align-items: center;
}

.name:hover {
  color: #3186ee;
}

.role_list_span {
  display: flex;
  align-items: center;
}

.change_div {
  padding: 8px;
  background: #fff;
  color: #a9a9a9;
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
}

.role_id_div {
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}

.people_count {
  cursor: pointer;
}

.people_count:hover {
  font-weight: 600;
  color: #3186ee;
}

.add_role_div {
  margin-top: 20px;
  text-align: center;
  padding: 5px;
  background-color: #0466dd;
  color: #fff;
  cursor: pointer;
}

.table_data1 {
  width: 100%;
  position: relative;
}

.role_list {
  padding: 7px 10px;
  background-color: #0466dd;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}

.role_list2 {
  padding: 7px 10px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #ededed;
  display: flex;
  justify-content: space-between;
}

.role_list2:hover {
  background-color: #edf2f9;
}

.content_tabs {
  display: flex;
  height: 100%;
}

.left_user_list {
  width: 200px;
  flex-shrink: 0;
  background-color: #fff;
  margin-right: 10px;
}

.table_menu_options:hover {
  color: #0466dd;
}

.table_menu_options {
  width: 150px;
  position: absolute;
  bottom: 20px;
  color: #ccc;
  font-size: 13px;
  text-align: center;
  cursor: pointer;
}

.table_box_inner {
  min-width: 150px;
  flex-shrink: 0;
  background-color: #fff;
  margin-right: 10px;
}

.avatar_div {
  flex-shrink: 0;
  width: 40px;
}

.name_box {
  display: flex;
  align-items: center;
}

.dimission_line {
  background-color: red;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  display: flex;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  width: calc(100% - 220px);
  position: absolute;
  right: 10px;
  top: 10px;
  height: calc(100vh - 20px);
  border-radius: 5px;
}

.main {
  background: #ececec;
  min-height: 100vh;
}
</style>
